var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('flex',{staticClass:"flex-wrap",attrs:{"items":_vm.items,"direction":"row"}})
}
var staticRenderFns = []

export { render, staticRenderFns }